import { IProduct } from './product';

export enum PaySource {
  ONE_CLICK = 'ONE_CLICK',
  PAYPAL = 'PAYPAL',
  KLARNA = 'KLARNA',
  CREDITCARD = 'CREDITCARD',
  APPLEPAY = 'APPLEPAY',
  GOOGLEPAY = 'GOOGLEPAY',
  PREPAID = 'PREPAID',
  WITHREACH_PAYPAL = 'WITHREACH_PAYPAL',
  STRIPE_KLARNA = 'STRIPE_KLARNA',
  PAYPAL_CONFIRM = 'PAYPAL_CONFIRM',
}

export interface IGeoResponse {
  ip: string;
  city: string;
  region: string;
  country: string;
  timezone: string;
  continent: string;
  regionCode: string;
  postalCode: string;
  isEUCountry: string;
  asOrganization: string;
}

export interface IZipValidateResponse {
  state: {
    zip: string;
    latitude: number;
    longitude: number;
    city: string;
    state: string;
    country: string;
  };
}

export interface IImportClickPayload {
  campaignId: number;
  sessionId?: string;
  client: string;
  pageType?: string;

  emailAddress?: string;
  ipAddress?: string;
  acceptHeader?: string;
  requestUri?: string;
  httpReferer?: string;
  userAgent?: string;
}

export interface IImportLeadPayload {
  orderId?: string;
  client: string;
  campaignId: number;
  sessionId: string; // custom_order_sid
  paymentMethod?: PaySource;
  paySource?: PaySource;

  customerId?: number;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  emailAddress: string;
  ipAddress: string;

  country: string;
  city: string;
  state: string;
  address1: string;
  postalCode: string;
  shipPostalCode?: string;
  billShipSame: boolean;

  sourceValue3?: string | undefined;
  affId?: string;
  custom_user_agent?: string;
  custom_receive_sms?: string;
  custom_sms_consent?: string;
  custom_http_referer?: string;
  custom_order_auid?: string;
  custom_order_10_off_vip?: string;
  custom_order_marketing_opt_in?: string;
  custom_order_language?: string;
  custom_gbraid?: string | string[];
  custom_taboola_clid?: string | string[];
  custom_gl?: string | string[];
  custom_gclid?: string | string[];
  custom_wbraid?: string | string[];
  custom_ob_click_id?: string | string[];
  custom_fbc?: string | string[];
  custom_fbp?: string | string[];
  custom_fbclid?: string | string[];
  custom_ttclid?: string | string[];
  custom_order_vlmid?: string | string[];
  custom_order_privacy_opt_in?: string | string[];
  custom_order_device_browser?: string;
  custom_order_device_browser_version?: string;
  custom_order_device_os?: string;
  custom_order_device_os_version?: string;
  custom_order_device_type?: string;
  custom_order_device_user_agent?: string;
  custom_order_mg_tracking_id?: string;
  custom2?: string;
  custom3?: string;
  auid?: string;
  initial?: string | 'skip';
  promo1?: string | 'skip';
  promo2?: string | 'skip';
  promo3?: string | 'skip';
  promo4?: string | 'skip';
  klarnaToken?: string;
  paymentType?: string;
}

export interface IImportLeadResponse {
  orderId: string;
  customerId: number;
}

interface ICustomFields {
  sid: string;
  auid: string;
  freeGift?: string;
  klarnaToken?: string;
  paymentType?: string;
  paymentMethod: PaySource;
  initial?: string | 'skip';
  promo1?: string | 'skip';
  promo2?: string | 'skip';
  promo3?: string | 'skip';
  promo4?: string | 'skip';
}

interface IOrderPayloadCustomFields {
  custom_order_sid: string;
  custom_order_auid: string;
  custom_order_freeGift?: boolean;
  custom_order_paymentType: string;
  custom_order_klarnaToken?: string;
  custom_order_paymentMethod: string; // Real PaySource
  custom_order_language?: string;

  custom_order_initial?: string;
  custom_order_promo1?: string;
  custom_order_promo2?: string;
  custom_order_promo3?: string;
  custom_order_promo4?: string;
  custom_order_order_flow?: string;
  custom_order_prev_order_id?: string;

  custom_order_affId?: string;
  custom_order_ttp?: string;
  custom_order_fbc?: string;
  custom_order_fbp?: string;
  custom_order_fbclid?: string;
  custom_order_gclid?: string;
  custom_order_ttclid?: string;
  custom_order_wbraid?: string;
  custom_order_gbraid?: string;
  custom_order_vlmid?: string;
  custom_order_ob_click_id?: string;
  custom_order_gl?: string;
  custom_order_vcid?: string | string[];
  custom_order_taboola_clid?: string;
  custom_order_http_referer?: string;
  custom_order_marketing_opt_in?: string;
  custom_order_ad_id?: string;
  custom_order_campaign_id?: string;
  custom_order_platform?: string;
  custom_order_publisher_name?: string;
  custom_order_site_id?: string;
  custom_order_creative_id?: string;
  custom_order_creative_name?: string;
  custom_order_flight_id?: string;
  custom_order_flight_name?: string;
  custom_order_mg_tracking_id?: string;
  custom_order_nb_tracking_id?: string;
  custom_order_newsbreak_cid?: string;
  custom_order_tb_click_id?: string;

  custom_order_device_browser?: string;
  custom_order_device_browser_version?: string;
  custom_order_device_os?: string;
  custom_order_device_os_version?: string;
  custom_order_device_type?: string;
  custom_order_device_user_agent?: string;
  custom_order_ev_click_id?: string;
}

export interface IImportOrderPaypalPayload extends IOrderPayloadCustomFields {
  affId?: string;
  client?: string;
  paySource?: string;
  prepaidType?: string;
  companyName?: string;
  fullUrl?: string;
  sourceValue3?: string; // Pass auid value to konnktive

  campaignId: number;
  orderId?: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  salesUrl: string;
  redirectsTo: string;
  errorRedirectsTo: string;
  paypalBillerId?: number;
  forceMerchantId?: number;
  emailAddress: string;
  phoneNumber?: string;
  preAuthBillerId?: string;
  sessionId?: string;
  custom1: string; // Ad id e.g. ad_id from url params
  custom2?: string;
  custom3?: string;
  note?: string;
  product2_id?: string;
  product2_price?: number;
  product2_shipPrice?: number;
  userAgent?: string;
  ipAddress?: string;
}

export interface IPayPalConfirmProps {
  ppToken: string;
  baToken?: string;
  payerId?: string;
  product: IProduct;
  sessionId: string;
  paypalMid: string;
  redirectTo: string;
}

export interface IPayPalConfirmPropsUpsell {
  orderId: string;
  ppToken: string;
  payerId?: string;
  product: IProduct;
  sessionId: string;
  redirectTo: string;
}

export interface IConfirmPaypalOrderPayload extends IOrderPayloadCustomFields {
  client?: string;
  sessionId: string;
  campaignId: number;
  emailAddress: string;
  paypalBillerId: string;
  token: string;
  baToken?: string;
  product1_id: string;
  phoneNumber?: string;
  product1_price: number | undefined;
  product1_shipPrice: number | undefined;
  page: string;
  payerId?: string;
  custom1: string;
  custom2?: string;
  custom3?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  note?: string;
  product2_id?: string;
  product2_price?: number;
  product2_shipPrice?: number;
  userAgent?: string;
  ipAddress?: string;
}

export interface IImportOrderCreditCardPayload
  extends IOrderPayloadCustomFields {
  client?: string;
  salesUrl: string;
  paySource?: string;
  companyName?: string;
  forceMerchantId?: number;
  forceLoadBalancerId?: number;
  fullUrl?: string;
  funnel?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  taxExemption?: string;

  errorRedirectsTo: string;
  redirectsTo: string;
  campaignId: number;
  orderId: string;
  cardNumber: string;
  cardYear: string;
  cardMonth: string;
  cardSecurityCode: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  address1: string;
  city: string;
  postalCode: string;
  shipPostalCode?: string;
  emailAddress: string;
  custom1: string;
  custom2?: string;
  custom3?: string;
  note?: string;
  product2_id?: string;
  product2_price?: number;
  product2_shipPrice?: number;
  userAgent?: string;
  ipAddress?: string;
}

export interface IImportOneClickPayload extends IOrderPayloadCustomFields {
  client: string;
  orderId: string;
  salesUrl: string;
  custom1: string;
  custom2?: string;
  custom3?: string;
  sessionId: string;
  campaignId: number;
  product1_id: string;
  redirectsTo: string;
  product1_price: number;
  errorRedirectsTo: string;
  product1_shipPrice: number;
  sourceValue3?: string;
  custom_user_agent?: string;
  custom_http_referer?: string;
  note?: string;
}

export interface IImportOrderApplePayPayload extends IOrderPayloadCustomFields {
  fullUrl?: string;
  client?: string;
  paySource: string;
  campaignId: number;
  orderId: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  emailAddress?: string;
  custom1: string;
  forceMerchantId: number;
  applePayToken: string;
  companyName?: string;
  custom2?: string;
  custom3?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  note?: string;
  userAgent?: string;
  ipAddress?: string;
}

export interface IImportOrderApplePayExpressPayload
  extends IOrderPayloadCustomFields {
  affId?: string;
  fullUrl?: string;
  client?: string;
  paySource: string;
  campaignId: number;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  emailAddress?: string;
  custom1: string;
  forceMerchantId: number;
  applePayToken: string;
  companyName?: string;
  custom2?: string;
  custom3?: string;
  sessionId?: string;
  firstName: string;
  lastName: string;
  address1?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
  phoneNumber?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  note?: string;
  userAgent?: string;
  ipAddress?: string;
}

export interface IPurchaseApplePayUpsellPayload
  extends IOrderPayloadCustomFields {
  emailAddress?: string;
  campaignId: number;
  orderId: string;
  product1_id: number;
  product1_price: number;
  product1_shipPrice: number;
  sessionId?: string;
  paySource: PaySource;
  klaviyo?: string;
  client: string;
  note?: string;
}

export interface IImportOrderGooglePayPayload
  extends IOrderPayloadCustomFields {
  fullUrl?: string;
  client?: string;
  paySource: string;
  campaignId: number;
  orderId: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  emailAddress?: string;
  custom1: string;
  forceMerchantId: number;
  googlePayToken: string;
  companyName?: string;
  custom2?: string;
  custom3?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  note?: string;
  userAgent?: string;
  ipAddress?: string;
}

export interface IPurchaseGooglePayUpsellPayload
  extends IOrderPayloadCustomFields {
  emailAddress?: string;
  campaignId: number;
  orderId: string;
  product1_id: number;
  product1_price: number;
  product1_shipPrice: number;
  sessionId?: string;
  paySource: PaySource;
  klaviyo?: string;
  client?: string;
  note?: string;
}

export interface IImportOrderResponse {
  orderId: string;
  paypalUrl: string;
  url: string;
  [keys: string]: string;
}

export interface IUpdateOrderPayload extends IOrderPayloadCustomFields {
  orderId: string;
  address1?: string;
  address2?: string;
  affId?: string;
  billShipSame?: boolean;
  city?: string;
  companyName?: string;
  country?: string;
  custom1?: string;
  custom2?: string;
  custom3?: string;
  custom4?: string;
  custom5?: string;
  emailAddress?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  postalCode?: string;
  shipAddress1?: string;
  shipAddress2?: string;
  shipCity?: string;
  shipCompanyName?: string;
  shipCountry?: string;
  shipFirstName?: string;
  shipLastName?: string;
  shipPostalCode?: string;
  shipState?: string;
  sourceValue1?: string;
  sourceValue2?: string;
  sourceValue3?: string;
  state?: string;
}

export interface IUpdateCustomerPayload {
  customerId: string;
  affId?: string;
  custom_ttp?: string;
  custom_fbc?: string;
  custom_fbp?: string;
  custom_fbclid?: string;
  custom_gclid?: string;
  custom_ttclid?: string;
  custom_wbraid?: string;
  custom_gbraid?: string;
  custom_order_vlmid?: string;
  custom_order_auid?: string;
  custom_ob_click_id?: string;
  custom_gl?: string;
  custom_user_agent?: string;
  custom_http_referer?: string;
  custom_taboola_clid?: string;
}

export interface IPurchaseCreditCardUpsellPayload
  extends IOrderPayloadCustomFields {
  salesUrl: string;
  redirectsTo: string;
  errorRedirectsTo: string;
  orderId: string;
  sessionId?: string;
  client: string;
  campaignId: number;
  paySource: PaySource;
  product1_id: number;
  product1_price: number;
  product1_shipPrice: number;
  forceMerchantId?: string;
  note?: string;
}

export interface IPurchasePayPalUpsellPayload
  extends IOrderPayloadCustomFields {
  orderId: string;
  sessionId?: string;
  client: string;
  campaignId: number;
  paySource: PaySource;
  product1_id: number;
  product1_price: number;
  product1_shipPrice: number;
  salesUrl: string;
  redirectsTo: string;
  errorRedirectsTo: string;
  note?: string;
  token?: string;
  paypalAccept?: number;
  payerId?: string;
}

export interface IKonnektiveProduct {
  productId: string;
  name: string;
  variantDetailId: string;
  variantName: string;
  merchantId: string;
  productDescription: string;
  clientId: string;
  externalProductId: string;
  qty: string;
  shipping: string;
  price: string;
  purchaseId: string;
  purchaseStatus: string;
  txnType: string;
  merchantTxnId: string;
  detailedStatus: string;
  nextBillDate: string;
  cancelAfterDate: string;
  productType: string;
  orderItemId: string;
  currentProduct: string;
  currentPrice: string;
  currentProductId: string;
  currentVariantDetailId: string;
  actualProductId: string;
  currentQty: string;
  clubPluginId: string;
  pauseScheduled: string;
  cancellationScheduled: string;
  salesTax: string;
  responseType: string;
  imageUrl: string;
}

export interface IQueryOrderResponse {
  orderId: string;
  totalAmount: string;
  price: string;
  address1: string;
  city: string;
  country: string;
  emailAddress: string;
  firstName: string;
  ipAddress: string;
  lastName: string;
  phoneNumber: string;
  postalCode: string;
  state: null | string;
  currencyCode: string;
  currencySymbol: string;
  products: IKonnektiveProduct[];
  sourceValue1: null | string;
  sourceValue2: null | string;
  sourceValue3: string;
  sourceValue4: null | string;
  sourceValue5: null | string;
  paySource: PaySource;
  customFields: ICustomFields;
}

// KLARNA
interface KlarnaBillingAddress {
  given_name: string;
  family_name: string;
  email: string;
  street_address: string;
  postal_code: string;
  city: string;
  region: string;
  phone: string;
  country: string;
}

interface MerchantUrls {
  confirmation: string;
  checkout?: string;
}

interface KlarnaOrderLine {
  name: string;
  quantity: number;
  unit_price: number;
  tax_rate: number;
  total_amount: number;
  total_tax_amount: number;
  reference?: string;
  image_url?: string;
}

export interface IGetKlarnaPaymentSessionPayload {
  client: string;
  authorizationToken?: string;
  intent: string;
  purchase_country: string;
  purchase_currency: string;
  locale: string;
  billing_address?: KlarnaBillingAddress;
  order_amount: number;
  order_tax_amount: number;
  order_lines: KlarnaOrderLine[];
  merchant_urls?: MerchantUrls;
}

export interface IImportOrderKlarnStripePayload
  extends IOrderPayloadCustomFields {
  client?: string;
  paySource?: string;
  prepaidType: string;
  companyName?: string;
  fullUrl?: string;
  funnel?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  phoneNumber?: string;
  campaignId: number;
  orderId: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  salesUrl: string;
  redirectsTo: string;
  errorRedirectsTo: string;
  forceMerchantId?: number;
  emailAddress: string;
  sessionId?: string;
  custom1: string;
  custom2?: string;
  custom3?: string;
  note?: string;
  product2_id?: string;
  product2_price?: number;
  product2_shipPrice?: number;
  userAgent?: string;
  ipAddress?: string;
}

export interface IImportUpsaleKlarnStripePayload
  extends IOrderPayloadCustomFields {
  client?: string;
  paySource?: string;
  prepaidType: string;

  campaignId: number;
  orderId: string;
  product1_id: string;
  product1_price: number;
  product1_shipPrice: number;
  salesUrl: string;
  redirectsTo: string;
  errorRedirectsTo: string;
  forceMerchantId?: string;
  sessionId?: string;
  note?: string;
}

export interface IImportOrderKlarnaPayload extends IOrderPayloadCustomFields {
  client?: string;
  quantity?: number;
  klarnaOrderId: string;
  klarnaAuthToken: string;
  paySource: string;
  forceMerchantId?: string;
  campaignId: number;
  orderId: string;
  product1_id: string;
  product1_price: number | undefined;
  product1_shipPrice: number | undefined;
  emailAddress: string;
  custom1: string;
  fullUrl?: string;
  sourceValue4: string;
  sourceValue5?: string;
  companyName?: string;
  currency: string;
  custom2?: string;
  custom3?: string;
  sourceValue3?: string; // Pass auid value to konnktive
  note?: string;
  product2_id?: string;
  product2_price?: number;
  product2_shipPrice?: number;
  userAgent?: string;
  ipAddress?: string;
}

export interface ICreateKlarnaCustomerTokenPayload {
  client: string;
  klarnaPayload: {
    customerToken: string;
    locale: string;
    purchase_currency: string;
    order_amount: number;
    order_tax_amount: number;
    order_lines: KlarnaOrderLine[];
    merchant_urls: MerchantUrls;
  };
  konnektivePayload: IOrderPayloadCustomFields & {
    orderId: string;
    currency: string;
    sessionId: string;
    campaignId: string;
    prepaidType: string;
    paySource: PaySource;
    product1_id: string;
    product1_price: number;
    product1_shipPrice: number;
    note?: string;
  };
}

export interface KlarnaAvailablePayment {
  asset_urls: {
    descriptive: string;
    standard: string;
  };
  identifier: string;
  name: string;
}

export interface IEverflowAddToCartEvent {
  client: string;
  transaction_id: string;
}

export interface IStartedCheckoutEvent {
  client: string;
  email: string;
  first_name?: string;
  last_name?: string;
  phone_number?: string;
  value?: number;
  Items?: any;
  locale?: string;
  country?: string;
  city?: string;
  timezone?: string;
  region?: string;
  ipAddress?: string;
  zipCode?: string;
  subProduct?: string;
}

export interface IFeatureFlagRequest {
  url: string;
  auid?: string;
  brand: string;
  orderId?: string;
  country: string;
}

type FlagPayload =
  | string
  | {
      name: string;
      [key: string]: unknown;
    };

export interface ICcFeatureFlag {
  name?: string;
  tax?: 'no_tax';
  brand: string;
  visa: number;
  mastercard: number;
  amex_discovery: number;
}

export interface IPpFeatureFlag {
  name?: string;
  brand: string;
  paypal_mid?: number;
  paypal_type?: 'express' | 'default' | 'reach';
}

export type FeatureFlags = Record<string, FlagPayload> & {
  controller_v?: string;
  cc_profile?: ICcFeatureFlag;
  pp_profile?: IPpFeatureFlag;
  stripe_pk?: string;
};
